/** @file Allocates an empty animation state (no tracks, no equips). */
import type { AnimState } from '../contracts/state';
import type { SkeletonData } from '../skeletonData';
import { resolveSkin } from '../skin/resolveSkin';

/** Empty state for data: no tracks, `skins: []`, `skin` = the resolved default skin. */
export function createState(data: SkeletonData): AnimState {
  return { tracks: [], queue: [], direction: null, skins: [], skin: resolveSkin(data, []), equipped: new Map() };
}
